import { render, staticRenderFns } from "./OtherReceivableModal.vue?vue&type=template&id=5418b0fb&scoped=true&"
import script from "./OtherReceivableModal.vue?vue&type=script&lang=js&"
export * from "./OtherReceivableModal.vue?vue&type=script&lang=js&"
import style0 from "./OtherReceivableModal.vue?vue&type=style&index=0&id=5418b0fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5418b0fb",
  null
  
)

export default component.exports